(function () {
    // Will trigger the link if you click on the arrow
    $('.FAQ h3').click(function (e) {
        $("a", $(this)).click();
    });
    $('.FAQ h3 a').click(function (e) {
        e.stopPropagation();
        window.location.href = $(this).attr('href');
    });
})();